import EZO_I2C	from "../ezo_i2c.js";
import semver from "semver";

class Module extends EZO_I2C {
  constructor(...args) {
    super(...args);

    this.id = "-";
    this.value = "-";
    this.status = "uninitialized";
    this.calibrationStatus = "-";
    this.temperatureCompensationStatus = "-";
    this.internalTemperature = "N/A";    
    
    /* publicate remote methods to clients */
    jfermi.RM_ezodo_clearCalibration = this.RM_ezodo_clearCalibration.bind(this);
    jfermi.RM_ezodo_calibrateTo0 = this.RM_ezodo_calibrateTo0.bind(this);
    jfermi.RM_ezodo_calibrateTo21 = this.RM_ezodo_calibrateTo21.bind(this);
    
  }
  async initialize() {
    try {
      await this.open("/dev/i2c-1", 0x61);      
      this.id = await this.command("i");
      //await this.command("O,mg,0");
      //await this.command("O,%,1");
      
      this.usbProductName = "ezo_do";
	  this.usbSerialNumber = "0x61";    
      this.name = "ezodoSensor";
      
      this.status = "ok";
    } catch(e) {
      this.status = "failed";
      throw e;
    }
  }
  async update(devices) {
    /* 
      from firmware version 2.13 we can use the RT command:
      RT,n set temperature compensation and take a reading

      //await this.command(`T,${devices.temperatureSensor.value?devices.temperatureSensor.value:25}`);
      //this.value = await this.command("R");
    */
    
    var T;
    if (devices.temperatureSensor)
      T = devices.temperatureSensor.value;
    if (devices.ezortdSensor)
      T = devices.ezortdSensor.value;    
    
    await this.command(`T,${T?T:25}`);
    this.temperatureCompensationStatus = await this.command("T,?");
    this.calibrationStatus = await this.command("Cal,?");
    this.value = parseFloat( await this.command("R") );    
  }
  clearCalibration() {
    return this.command("Cal,clear");
  }
  calibrateTo0() {
    return this.command("Cal,0");
  }
  calibrateTo21() {
    return this.command("Cal");
  }
  async RM_ezodo_clearCalibration(request) {
    try {
      var result = await this.clearCalibration();
      console.log(`${request.client.username}: Dissolved Oxygen Sensor calibration data has successfully been deleted`);
    } catch(e) {
      console.error(`${request.client.username}: Clear calibration failed: ${e}`);
      throw Error(e);
    }
    return true;
  }
  async RM_ezodo_calibrateTo0(request) {
    try {
      var result = await this.calibrateTo0();
      console.log(`${request.client.username}: Dissolved Oxygen Sensor has successfully been calibrated to 0 dissolved oxygen level`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e}`);
      throw Error(e);
    }
    return true;
  }
  async RM_ezodo_calibrateTo21(request) {
    try {
      var result = await this.calibrateTo21();
      console.log(`${request.client.username}: Dissolved Oxygen Sensor has successfully been calibrated to atmospheric oxygen level`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e}`);
      throw Error(e);
    }
    return true;
  }  
  toJSON() {
    return({
      id: this.id,
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,            
      status: this.status,
      temperatureCompensationStatus: this.temperatureCompensationStatus,
      calibrationStatus: this.calibrationStatus,
      value: this.value
    });
  }
}

export default Module;